import { render, staticRenderFns } from "./TariffTile.vue?vue&type=template&id=ffa50576&scoped=true&lang=pug&"
import script from "./TariffTile.vue?vue&type=script&lang=js&"
export * from "./TariffTile.vue?vue&type=script&lang=js&"
import style0 from "./TariffTile.vue?vue&type=style&index=0&id=ffa50576&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffa50576",
  null
  
)

export default component.exports